export default __webpack_public_path__ + "static/media/tool-hand.81dffed4.svg";